import React from "react";
import { Icon, Button } from "@blueprintjs/core";

export function PreviewGenerate(editor) {
  const { Canvaseditor } = editor; 
  // Save & Download.
  const downloadHighQualityImage = (canvas, scaleFactor = 2) => {
    // Set desired width and height for the high-quality image
    const width = canvas.getWidth();
    const height = canvas.getHeight();

    // Scale the canvas temporarily for higher resolution
    const originalWidth = canvas.width;
    const originalHeight = canvas.height;

    // Scale up the canvas
    canvas.setDimensions({
      width: width * scaleFactor,
      height: height * scaleFactor,
    });
    canvas.setZoom(scaleFactor);

    // Generate data URL with high resolution
    const dataURL = canvas.toDataURL({
      format: "png", // Use 'jpeg' for JPEG format
      quality: 1, // Quality factor (1 is the highest quality)
    });

    // Reset canvas dimensions and zoom
    canvas.setDimensions({ width: originalWidth, height: originalHeight });
    canvas.setZoom(1);

    // Create a temporary download link
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = "useToprint-img.png"; // Set download filename
    link.click();
  };

  return (
    <div className="bp4-navbar-group bp4-align-left margin-right-10">
      <Button
        onClick={() => downloadHighQualityImage(Canvaseditor)}
        icon={<Icon icon="download" />}
        text="Download"
      />
    </div>
  );
}
